import React, { Component } from "react";

import { CRUDFunction } from "../../reduxCURD/container";
import ThisTable from "../Common/ThisTable";
import SpinnerLoader from "../Common/SpinnerLoader";
import { curdActions } from "../../reduxCURD/actions";
import { penaltiesArrayWithValues } from "../Reports/FRA/TrackViolationReport/CivilPenalties_213";
import _ from "lodash";
import { ReportGeneratorUtils } from "../Reports/utils/reportGeneratorUtils";
import { languageService } from "../../Language/language.service";
import { Col, Row } from "reactstrap";
import { themeService } from "../../theme/service/activeTheme.service";
import { commonPageStyle } from "../Common/Summary/styles/CommonPageStyle";
import { CommonSummaryStyles } from "../Common/styles";
import { Container } from "reactstrap";
import { trackReportStyle } from "../Reports/Timps/style";
class ReportSummary extends Component {
  constructor(props) {
    super(props);

    this.state = {
      violationReports: [],
      groupedViolationReports: [],
    };

    this.groupReportsByUser = this.groupReportsByUser.bind(this);
    this.extractViolationFromReports = this.extractViolationFromReports.bind(this);
    this.getViolationPenalty = this.getViolationPenalty.bind(this);
    this.columns = [
      {
        Header: languageService("Locations"),
        accessor: "lineName",
        minWidth: 200,
      },
      {
        Header: languageService("Number of Violations"),
        accessor: "count",
        minWidth: 100,
      },

      { Header: languageService("Total Penalty ($)"), accessor: "sum", minWidth: 100 },
    ];
  }

  componentDidMount() {
    let arg = "inspection/?viol=true" + "&rId=" + "33";
    this.props.getReportSummary(arg);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.actionType !== this.props.actionType && this.props.actionType === "REPORTSUMMARY_READ_SUCCESS") {
      this.extractViolationFromReports(this.props.reportSummary);
    }
  }

  extractViolationFromReports(data) {
    let violationReports = [];
    data.forEach((inspec) => {
      let formSummaries = ReportGeneratorUtils.getInspectionTableAppForms(inspec, ["trackViolationReportForm"]);
      formSummaries.forEach((form) => {
        violationReports.push({
          _id: inspec._id,
          date: inspec.date,
          lineId: inspec.lineId,
          lineName: inspec.lineName,
          title: inspec.title,
          user: inspec.user,
          violation: form.inspectorviolno,
          willfull: form.willfull,
        });
      });
    });

    this.groupReportsByUser(violationReports);
  }

  groupReportsByUser(data) {
    const groupedByUser = data.reduce((acc, item) => {
      const userId = item && item.user && item.user.id;
      if (!acc[userId]) {
        acc[userId] = [];
      }
      acc[userId].push(item);
      return acc;
    }, {});

    const result = Object.keys(groupedByUser).map((userId) => {
      const userGroup = groupedByUser[userId];
      const groupedByLineId = userGroup.reduce((acc, item) => {
        const lineId = item && item.lineId;
        const penalty = this.getViolationPenalty(item.violation, item.willfull);

        if (penalty) {
          !acc[lineId] && (acc[lineId] = { lineName: item.lineName, count: 0, sum: 0 });
          acc[lineId].count++;
          acc[lineId].sum += penalty;
        }
        return acc;
      }, {});
      const userName = userGroup[0].user.name;
      const userGroupArray = Object.entries(groupedByLineId).map(([lineId, details]) => ({
        lineId,
        ...details,
      }));
      return { _id: userId, name: userName, userGroup: userGroupArray };
    });

    this.setState({ violationReports: data, groupedViolationReports: result });
  }

  getViolationPenalty(violation, isWillfull) {
    let found = penaltiesArrayWithValues.find((pen) => pen.rule == violation);

    if (found) {
      return isWillfull ? found.willfull : found.notwillfull;
    }
    return false;
  }

  render() {
    return (
      <Col className="mainContent" md={12}>
        <h2 style={{ ...themeService(trackReportStyle.headingStyle), transform: "none", fontSize: "22px" }}>
          {languageService("Violations Report Summary")}
        </h2>
        <hr style={{ borderBottom: "1px solid rgb(209, 209, 209)", width: "96.5%" }}></hr>
        {this.state.groupedViolationReports.length > 0 && (
          <RenderSummaryData userGroupData={this.state.groupedViolationReports} columns={this.columns} />
        )}
      </Col>
    );
  }
}
let actionOptions = {
  create: true,
  update: false,
  read: true,
  delete: false,
};

const RenderSummaryData = ({ userGroupData, columns }) => {
  return userGroupData.map((user) => {
    return (
      <div style={{ display: "flex", flexDirection: "row", flexWrap: "nowrap", justifyContent: "space-around" }}>
        <Col md={6}>
          <div style={{ ...themeService(CommonSummaryStyles.CommonSummaryStylesHeadingContainer), display: "inline-block" }}>
            <h4 style={themeService(CommonSummaryStyles.CommonSummaryStylesHeadingStyle)}>{user.name}</h4>
          </div>

          <ThisTable
            tableColumns={columns}
            tableData={user.userGroup}
            //pageSize={15}
            minRows={1}
            pagination={false}
            forDashboard={false}
            // handlePageChange={(page) => this.handlePageSave(page)}
            //page={0}
            height={"auto"}
            // handleSelectedClick={this.setSelectedUser}
            onClickSelect
          />
          <br></br>
        </Col>
      </div>
    );
  });
};

let ReportSummaryContainer = CRUDFunction(ReportSummary, "reportSummary", actionOptions, null, null, "journeyPlan/report");
export default ReportSummaryContainer;



// WEBPACK FOOTER //
// ./src/components/ReportSummary/index.jsx